module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-499.493154a.woff2";